<template>
  <div class="app-container" style="text-align: left" v-show="isLogin">
    <div style="font-weight: bold; font-size: 16px; color: rgb(85, 85, 85)">
      订单自动发送
    </div>
    <br />
    <div>
      <el-switch
        :active-value="1"
        active-color="#0850fc"
        :inactive-value="0"
        inactive-color="rgb(187 187 187)"
        v-model="tbwl_auto"
        @change="autoSendOnOff(2)"
      />
      &nbsp;&nbsp;&nbsp;
      <span style="font-size: 15px; font-weight: bold">同步物流自动发送</span
      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <span
        style="
          font-size: 15px;
          font-weight: bold;
          color: #f7aa35;
          border: #f7aa35 2px solid;
          border-radius: 1em;
        "
        >&nbsp;?&nbsp;</span
      >&nbsp;&nbsp;
      <span style="font-size: 14px; color: #f7aa35"
        >支持：D速同步， 极速同步，韵达延迟单同步</span
      >
    </div>
    <div>
      <el-button
        type="primary"
        style="
          font-size: 13px;
          background-color: #0850fc;
          color: white;
          height: 38px;
          border-radius: 0.5em;
          margin-left: 59px;
          margin-top: 10px;
        "
        @click="getZdSendInfo"
        >物流设置</el-button
      >
    </div>

    <br />
    <div>
      <el-switch
        :active-value="1"
        active-color="#0850fc"
        :inactive-value="0"
        inactive-color="rgb(187 187 187)"
        v-model="fhcs_auto"
        @change="autoSendOnOff(1)"
      />
      &nbsp;&nbsp;&nbsp;
      <span style="font-size: 15px; font-weight: bold">即将发货超时订单自动发送</span
      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <span
        style="
          font-size: 15px;
          font-weight: bold;
          color: #f7aa35;
          border: #f7aa35 2px solid;
          border-radius: 1em;
        "
        >&nbsp;?&nbsp;</span
      >&nbsp;&nbsp;
      <span style="font-size: 14px; color: #f7aa35">支持:礼品单， 退款单</span>
    </div>
    <div>
      <el-button
        type="primary"
        style="
          font-size: 13px;
          background-color: #0850fc;
          color: white;
          height: 38px;
          border-radius: 0.5em;
          margin-left: 59px;
          margin-top: 10px;
        "
        @click="getTimeoutZdSendInfo"
        >物流设置</el-button
      >
    </div>
    <br />
    <div style="font-weight: bold; font-size: 16px; color: rgb(85, 85, 85)">
      自动发送记录列表
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      highlight-current-row
      style="color: rgb(70, 70, 70); margin-top: 10px"
      :row-style="{ height: '0' }"
      :cell-style="{ padding: '3px 0' }"
      :header-cell-style="{
        background: 'rgb(247 248 252) !important',
        color: '#ededed  !important',
        padding: '7px 0',
        color: 'rgb(140, 140, 140)',
      }"
    >
      <el-table-column label="序号" prop="ID" align="left" min-width="1">
        <template slot-scope="{ row }">
          <span>{{ row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="信息" min-width="6" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.ext">{{ row.ext }}</span>
        </template>
      </el-table-column>
      <el-table-column label="时间" min-width="3" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.created_at">{{ row.created_at }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      layout="total, prev, pager, next"
      style="padding-top: 12px; padding-bottom: 0px"
      @pagination="getList"
    />

    <!-- 物流设置 弹出框 -->
    <el-dialog
      :title="textMap[dialogTitle]"
      :visible.sync="dialogFormVisible"
      style="height: 120vh; width: 130vw; top: -14vh; left: -15vw"
    >
      <el-form :model="temp" label-width="30px" style="width: 100%">
        <el-form-item style="margin-top: -20px">
          <div
            class="platDiv"
            @click="addClass(1)"
            :class="{ spanColors: platform === 1 }"
          >
            <img
              src="@/assets/tb.png"
              style="position: relative; width: 30px; height: auto; margin-left: -2.3px"
            />
            <span class="platSpan">淘宝</span>
          </div>
          <div
            class="platDiv"
            style="width: 96px"
            @click="addClass(2)"
            :class="{ spanColors: platform === 2 }"
          >
            <img
              src="@/assets/pdd.png"
              style="
                position: relative;
                width: 30px;
                height: auto;
                margin-left: -2px;
                margin-top: -1px;
              "
            />
            <span class="platSpan">拼多多</span>
          </div>
          <div
            class="platDiv"
            @click="addClass(3)"
            :class="{ spanColors: platform === 3 }"
          >
            <img
              src="@/assets/dy.png"
              style="
                position: relative;
                width: 30px;
                height: auto;
                margin-left: -2px;
                margin-top: -1px;
              "
            />
            <span class="platSpan">抖音</span>
          </div>
          <div
            class="platDiv"
            @click="addClass(4)"
            :class="{ spanColors: platform === 4 }"
          >
            <img
              src="@/assets/jd.jpeg"
              style="
                position: relative;
                width: 30px;
                height: auto;
                margin-left: -2px;
                border-radius: 0.5em;
              "
            />
            <span class="platSpan">京东</span>
          </div>
          <div
            class="platDiv"
            @click="addClass(5)"
            :class="{ spanColors: platform === 5 }"
          >
            <img
              src="@/assets/ks.png"
              style="
                position: relative;
                width: 30px;
                height: auto;
                margin-left: -2px;
                border-radius: 0.5em;
              "
            />
            <span class="platSpan">快手</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div
            v-show="this.dialogTitle == 'auto'" style="color:red">
            <div style="margin-top:-5px">同步单模式分以下3种:</div> 
              <div style="margin-top:-15px">1.中通转中通，韵达转韵达(只能上家是中通或韵达的才能使用，优势:相同快递转单售后少)</div> 
              <div style="margin-top:-15px">2.普通地区</div> 
              <div style="margin-top:-15px">3.偏远地区</div> 
              <div style="margin-top:-15px">以上不同类别仓库可同时选一个快递仓库，系统根据订单信息自动匹配发货</div> 
          </div>
          <div v-show="this.dialogTitle == 'auto'" style="margin-top: 10px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <span style="font-weight: bold; font-size: 16px; color: rgb(85, 85, 85);">代发仓库</span>
              <el-button
                type="primary"
                icon="el-icon-plus"
                circle
                size="small"
                style="margin-left: 10px; background-color: #0850fc;"
                @click="addDaifaWarehouse"
              ></el-button>
            </div>
            <div v-for="(parcel, index) in daifaWarehouses" :key="index" style="display: flex; align-items: center; gap: 15px; margin-bottom: 10px;">
              <span style="font-weight: bold; min-width: 80px;">代发仓库{{ index + 1 }}:</span>
              <div style="flex: 1;">
                <el-select
                  style="width: 100%"
                  v-model="parcel.warehouse_id"
                  @change="onDaifaWarehouseChange(index)"
                  placeholder="仓库名称"
                  class="filter-item"
                >
                  <el-option
                    v-for="item in tbd_cangkuList"
                    :key="parseInt(item.id)"
                    :label="item.desc_name"
                    :value="item.id + ''"
                  >
                    <span>
                      <img
                        v-if="item.kuaidi && item.kuaidi.pic"
                        :src="item.kuaidi.pic"
                        alt="图标"
                        style="width: 60px; height: 30px; margin-right: 8px"
                      />
                      {{ item.desc_name }}
                    </span>
                  </el-option>
                </el-select>
              </div>
              <div style="flex: 1;">
                <el-select
                  style="width: 100%"
                  v-model="parcel.gift_ids"
                  placeholder="礼品"
                  class="filter-item"
                >
                  <el-option
                    v-for="item in daifaWarehouseGifts[index]"
                    :key="parseInt(item.id)"
                    :label="item.name + ' ￥' + item.price"
                    :value="item.id + ''"
                  >
                    <span>
                      <img
                        v-if="item && item.pic"
                        :src="item.pic"
                        alt="图标"
                        style="width: 40px; height: 40px; margin-right: 8px; vertical-align: middle;"
                      />
                      {{ item.name }} ￥{{ item.price }}
                    </span>
                  </el-option>
                </el-select>
              </div>
              <el-button
                type="text"
                style="color: red; min-width: 50px;"
                @click="removeDaifaWarehouse(index)"
              >删除</el-button>
            </div>
          </div>

          <el-select
            v-show="this.dialogTitle == 'timeout'"
            style="width: 15vw"
            v-model="temp.id"
            @change="cangkuClick"
            class="filter-item"
          >
            <el-option
              v-for="item in lpd_cangkuList"
              :key="parseInt(item.id)"
              :label="item.desc_name"
              :value="item.id + ''"
            >
              <span>
                <img
                  v-if="item.kuaidi && item.kuaidi.pic"
                  :src="item.kuaidi.pic"
                  alt="图标"
                  style="width: 60px; height: 30px; margin-right: 8px"
                />
                {{ item.desc_name }}
              </span>
            </el-option>
          </el-select>
          <!-- <el-input style="width: 12vw" v-model="temp.fhAddress" disabled /> -->
          <!-- <span style="margin-left: 20px">发货地址：{{ temp.fhAddress }} </span> -->
        </el-form-item>

        <el-form-item>
          <span>发件人姓名:</span
          ><el-input
            style="width: 6vw; margin-left: 7px; height: 29px"
            v-model="send_name"
            placeholder="刘先生"
          ></el-input>
          <span style="margin-left: 1vw">发件人电话:</span>
          <span
            style="
              border: 1px solid #dcdfe6;
              width: 132px;
              padding: 12px 10px;
              border-radius: 0.3em;
            "
          >
            <el-dropdown trigger="click" placement="bottom-start">
              <span class="el-dropdown-link">
                {{ send_tel }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, index) in sendtelList"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                  <!-- <div style="display: flex; justify-content: space-between; align-items: center;"> -->
                  <span @click="liClicked(item)">{{ item }}</span> &nbsp;&nbsp;&nbsp;
                  <el-button type="text" style="color: red" @click="deleteItem(item)"
                    >删除</el-button
                  >
                  <!-- </div> -->
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
          <el-button
            style="
              font-size: 12px;
              color: #0850fc;
              border-color: #0850fc;
              height: 34px;
              border-radius: 0.5em;
              padding: 3px 10px;
              margin-left: 1vw;
              width: 80px;
            "
            @click="sendCodeCheck()"
            >添加手机号</el-button
          >
          <!-- <div style="margin-top: -48px; margin-left: 31vw; width: 25vw">
            <span style="color: red"
              >验证说明:请填写可接听电话手机号，作为发件人电话。<br />此电话将作为物流派送和投诉电话使用，请随时接听物流派送或投诉等问题.</span
            >
          </div> -->
        </el-form-item>
        <el-form-item v-show="this.dialogTitle == 'auto'">
          <span>自定义收货人电话：</span>
          <el-input
            style="width: 15vw"
            v-model="temp.zdy_phone"
            placeholder="15133332222"
          ></el-input>
        </el-form-item>

        <el-form-item>
          店铺分组：
          <el-select
            v-model="temp.shop_group_name"
            class="filter-item"
            style="width: 10vw"
            @change="getShowNameByGroup"
            clearable
          >
            <el-option label="全部" value="全部">全部</el-option>
            <el-option
              v-for="(sitem, sindex) in shopGroupList"
              :key="sindex"
              :label="sitem"
              :value="sitem"
              >{{ sitem }}</el-option
            >
          </el-select>

          <span style="margin-left: 2vw">店铺名：</span>
          <el-select
            v-model="temp.show_name"
            class="filter-item"
            style="width: 10vw"
            clearable
          >
            <el-option label="全部" value="全部">全部</el-option>
            <el-option
              v-for="(citem, cindex) in shopList"
              :key="cindex"
              :label="citem"
              :value="citem"
              >{{ citem }}</el-option
            >
          </el-select></el-form-item
        >

        <el-form-item>
          <span style="font-weight: bold">旗子状态：</span>
          <input type="checkbox" id="otCheckAll" v-model="isAllOt_Selected" />
          <label for="otCheckAll">全选</label>&nbsp;&nbsp;
          <input type="checkbox" :value="orderTypes[0]" v-model="temp.flag" />
          <i class="el-icon-s-flag" style="color: gray" />&nbsp;&nbsp;
          <input type="checkbox" :value="orderTypes[1]" v-model="temp.flag" />
          <i class="el-icon-s-flag" style="color: red" />&nbsp;&nbsp;
          <input type="checkbox" :value="orderTypes[2]" v-model="temp.flag" />
          <i class="el-icon-s-flag" style="color: #ede700" />&nbsp;&nbsp;
          <input type="checkbox" :value="orderTypes[3]" v-model="temp.flag" />
          <i class="el-icon-s-flag" style="color: green" />&nbsp;&nbsp;
          <input type="checkbox" :value="orderTypes[4]" v-model="temp.flag" />
          <i class="el-icon-s-flag" style="color: blue" />&nbsp;&nbsp;
          <input type="checkbox" :value="orderTypes[5]" v-model="temp.flag" />
          <i class="el-icon-s-flag" style="color: #ca01e3" />
        </el-form-item>
        <el-form-item>
          <span style="font-weight: bold">采购平台：</span>
          <label for="bpCheckAll"
            ><input type="checkbox" id="bpCheckAll" v-model="isAllbp_Selected" />
            全选</label
          >&nbsp;&nbsp;
          <label v-for="(item, index) in buyPlatforms" :key="index">
            <input type="checkbox" :value="item" v-model="temp.cg_platform" />
            {{ item }}&nbsp;&nbsp;
          </label>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <span
            style="font-weight: bold; margin-left: 38px"
            v-show="this.dialogTitle == 'auto'"
            >礼品单双包裹：</span
          >
          <input
            type="radio"
            :value="1"
            v-model="temp.express_type"
            v-show="this.dialogTitle == 'auto'"
          />
          <label v-show="this.dialogTitle == 'auto'">是</label>&nbsp;&nbsp;
          <input
            type="radio"
            :value="0"
            v-model="temp.express_type"
            v-show="this.dialogTitle == 'auto'"
          />
          <label v-show="this.dialogTitle == 'auto'">否</label>
        </el-form-item>

        <el-form-item v-show="this.dialogTitle == 'auto'">
          <span style="font-weight: bold">需要匹配快递名称：</span>
          <label for="kdCheckAll"
            ><input type="checkbox" id="kdCheckAll" v-model="isAllkd_Selected" />
            全选</label
          >&nbsp;&nbsp;
          <label v-for="(item, index) in kuaidiLists" :key="index">
            <input type="checkbox" :value="item" v-model="temp.kuai_name" />
            {{ item }}&nbsp;&nbsp;
          </label>
        </el-form-item>

        <el-form-item v-show="this.dialogTitle == 'auto'">
          <span style="font-weight: bold">订单状态：</span>
          <input type="radio" :value="3" v-model="temp.wuhuoyu_orderStatus" />
          <label>待发货,已有上家单号</label>
        </el-form-item>
        <el-form-item v-show="this.dialogTitle == 'timeout'">
          <span>订单状态：</span>
          <input type="radio" :value="1" v-model="temp.orderStatus" />
          <label>待下单</label>
          <input type="radio" :value="2" v-model="temp.orderStatus" />
          <label>待发货</label>
          <input type="radio" :value="4" v-model="temp.orderStatus" />
          <label>待下单和待发货</label>
          &nbsp;&nbsp;&nbsp;&nbsp; 剩余
          <el-input type="number" min="0" v-model="temp.cstime" style="width: 80px" />
          小时超时订单自动发送
        </el-form-item>
        <el-form-item
          ><span>【注】开启后30分钟整点自动匹配一次，例如如8:30 9:00</span></el-form-item
        >
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false"> 取消 </el-button>
        <el-button type="primary" @click="autoSendGoodsOn('')">保存 </el-button>
      </div>
    </el-dialog>

    <!-- 韵达错误数据弹出框 -->
    <el-dialog
      title="韵达错误数据"
      :visible.sync="yunda_dialogFormVisible"
      style="text-align: center; width: 100%; height: 120%; overflow-y: auto"
    >
      <el-form
        :model="yundaErrorData"
        style="
          width: 100%;
          height: 100%;
          overflow-y: auto;
          white-space: pre-line;
          text-align: left;
        "
      >
        <el-form-item>
          <span>
            {{ yundaErrorData.data }}
          </span></el-form-item
        >
      </el-form>
    </el-dialog>

    <!-- 短信验证弹出框 -->
    <el-dialog
      title="添加手机号-短信验证"
      :visible.sync="sendCodeFormVisible"
      style="
        text-align: center;
        width: 60%;
        height: 120%;
        overflow-y: auto;
        padding: 0px;
        margin-left: 16%;
        margin-top: 5%;
      "
    >
      <el-form
        class="form"
        :model="phoneForm"
        :rules="rules"
        ref="phoneForm"
        label-width="0px"
      >
        <!-- <div style="margin-bottom: 20px; color: red">
          因移动手机号运营商问题，验证码接收失效率高，尽量切换电信或联通手机号
        </div> -->
        <el-form-item prop="phone">
          <el-input
            v-model="phoneForm.phone"
            placeholder="请输入手机号"
            prefix-icon="el-icon-mobile-phone"
          ></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input
            v-model="phoneForm.code"
            placeholder="请输入验证码"
            prefix-icon="el-icon-chat-line-round"
          ></el-input>
          <!-- <a type="button" @click="sendCode">获取验证码</a> -->
          <a type="button" @click="sendCode" :disabled="countdown > 0">
            {{ countdown > 0 ? `${countdown}秒后重新获取` : "获取验证码" }}
          </a>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateUserInfo()"> 确认 </el-button>
        <el-button @click="sendCodeFormVisible = false"> 取消 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import waves from "@/directive/waves"; // waves directive
import "@/assets/custom-theme/index.css"; // the theme changed version element-ui css
import Pagination from "@/components/Pagination";
import "element-ui/lib/theme-chalk/index.css";

export default {
  name: "autoSend",
  directives: { waves },
  components: {
    Pagination,
  },
  data() {
    return {
      userName: "",
      user_balance: 0.0,
      userType: "",
      userToken: Cookies.get("view_userToken"),
      isLogin: false,
      tbwl_auto: 0,
      fhcs_auto: 0,
      listLoading: false,
      listQuery: {
        id: "",
        page: 1,
        // per_page: 20,
        name: "",
        email: "",
        uuid: "",
        daili: "",
        user_type: "",
        is_promoter: "",
        system_id: "",
      },
      list: [],
      total: 0,
      dialogFormVisible: false,
      yunda_dialogFormVisible: false,
      dialogTitle: "",
      textMap: {
        auto: "上家物流同步发送设置",
        timeout: "超时订单发送设置",
      },
      goods: [],
      temp: {
        id: "",
        ids: [],
        type: 0,
        zdy_phone: "",
        fjr: "",
        kuaidi_price: "",
        // goods_price: "",
        // goods_id: "",
        gift_status: 1,
        wuhuoyu_orderStatus: 3,
        orderStatus: 4,
        cstime: 0,
        kuai_name: [],
        cg_platform: [],
        flag: [],
        show_name: "全部",
        shop_group_name: "全部",

        kuaidi_name: "",
        fhAddress: "",
        express_type: 0,
        // 备选仓库
        standby_express: [],
        bx_fhAddress: "",
        //设置某平台的仓库
        platform: 1,
      },
      shopList: [],
      shopGroupList: [],
      bpCheckAll: true,
      otCheckAll: true,
      orderTypes: [0, 1, 2, 3, 4, 5],
      buyPlatforms: ["淘宝", "淘特", "1688", "拼多多", "抖音"],
      kdCheckAll: true,
      kuaidiLists: [
        "中通",
        "圆通",
        "申通",
        "韵达",
        "邮政",
        "极兔",
        "德邦",
        "顺丰",
        "丰网",
      ],
      cangkuList: [],
      tbd_cangkuList: [],
      lpd_cangkuList: [],
      platList: [
        { value: 1, name: "淘宝" },
        { value: 2, name: "拼多多" },
        { value: 3, name: "抖音" },
        { value: 4, name: "京东" },
      ],
      yundaErrorData: { data: "" },
      orderStasList: [
        { value: 1, name: "待下单" },
        { value: 2, name: "待发货" },
        { value: 4, name: "待下单和待发货" },
      ],
      platform: 1,
      send_name: "",
      send_tel: "",
      sendtelList: [],
      sendCodeFormVisible: false,
      phoneForm: {
        phone: "",
        code: "",
      },
      countdown: 0, // 倒计时时间
      rules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "手机号格式错误", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      tbdRemarks: 
          "同步单模式分以下3种:\n\
1.中通转中通，韵达转韵达(只能上家是中通或韵达的才能使用，优势:相同快递转单售后少)\r\n\
2.普通地区\r\n\
3.偏远地区\r\n\
以上不同类型仓库可同时选一个快递仓库，系统根据订单信息自动匹配发货",
      df_ids: [],
      df_standby_express: [],
      daifaWarehouses: [], // 代发仓库数组
      daifaWarehouseGifts: [], // 每个代发仓库对应的礼品列表
    };
  },
  created() {
    // 判断 登录userToken是否有效 userToken == '' ||
    const userToken = Cookies.get("view_userToken");

    if (userToken == undefined) {
      this.isLogin = false;
      this.$confirm("请先登录再使用！", "提示", {
        confirmButtonText: "确定",
      })
        .then(() => {
          // 重新导航到登录页面
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/login" });
        })
        .catch(() => {
          // 重新导航到首页
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/" });
        });
      return;
    } else {
      this.isLogin = true;
    }
    this.$root.getUserInfo();
    const tbwl_auto = Cookies.get("view_tbwl_auto");
    if (tbwl_auto == 1 || tbwl_auto == "1") {
      this.tbwl_auto = 1;
    }
    const fhcs_auto = Cookies.get("view_fhcs_auto");
    if (fhcs_auto == 1 || fhcs_auto == "1") {
      this.fhcs_auto = 1;
    }
    if (
      Cookies.get("view_sendName") != null &&
      Cookies.get("view_sendName") != "null" &&
      Cookies.get("view_sendName") != "" &&
      Cookies.get("view_sendName") != "undefined" &&
      Cookies.get("view_sendName") != undefined
    ) {
      this.send_name = Cookies.get("view_sendName");
    }
    if (
      Cookies.get("view_sendTel") != null &&
      Cookies.get("view_sendTel") != "null" &&
      Cookies.get("view_sendTel") != "" &&
      Cookies.get("view_sendTel") != "undefined" &&
      Cookies.get("view_sendTel") != undefined
    ) {
      this.sendtelList = JSON.parse(Cookies.get("view_sendTel"));
    }

    if (
      Cookies.get("view_fjr") != null &&
      Cookies.get("view_fjr") != "null" &&
      Cookies.get("view_fjr") != undefined &&
      Cookies.get("view_fjr") != "undefined"
    ) {
      const fjrStr = Cookies.get("view_fjr");
      this.temp.fjr = fjrStr;
      const index = fjrStr.indexOf(",");
      if (index != -1) {
        const st = fjrStr.substring(index + 1); // 逗号后面的部分
        if (this.sendtelList.indexOf(st) != -1) {
          this.send_tel = st;
        }
      }
      const index1 = fjrStr.indexOf("，");
      if (index1 != -1) {
        const st1 = fjrStr.substring(index1 + 1);
        if (this.sendtelList.indexOf(st1) != -1) {
          this.send_tel = st1;
        }
      }
    } else {
      this.temp.fjr = "";
    }

    this.addClass("1");
    this.getList();
    this.getYunDaError();
  },
  computed: {
    // 旗帜状态 全选事件
    isAllOt_Selected: {
      get() {
        return this.temp.flag.length === this.orderTypes.length;
      },
      set(value) {
        if (value) {
          this.temp.flag = this.orderTypes.slice();
        } else {
          this.temp.flag = [];
        }
      },
    },
    // 采购平台 全选事件
    isAllbp_Selected: {
      get() {
        return this.temp.cg_platform.length === this.buyPlatforms.length;
      },
      set(value) {
        if (value) {
          // this.buyPlatforms.forEach((item) => {
          //   this.cg_platform.push(item.name);
          // });
          this.temp.cg_platform = this.buyPlatforms.slice();
        } else {
          this.temp.cg_platform = [];
        }
      },
    },
    // 匹配快递 全选事件
    isAllkd_Selected: {
      get() {
        return this.temp.kuai_name.length === this.kuaidiLists.length;
      },
      set(value) {
        if (value) {
          // this.kuaidiLists.forEach((item) => {
          //   this.kuai_name.push(item);
          // });
          this.temp.kuai_name = this.kuaidiLists.slice();
        } else {
          this.temp.kuai_name = [];
        }
      },
    },
  },
  methods: {
    getList() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.listLoading = true;
      const url = this.$root.commonPreUrl + "/index/zdSendLog";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: this.listQuery,
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.list = resd.data.data;
            this.total = resd.data.total;
            this.listLoading = false;
          }
          setTimeout(() => {}, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, // 是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }
        });
    },
    // 同步单自动发货物流设置  获取弹窗信息
    getZdSendInfo() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.resetTemp();
      this.df_ids = [];
      this.df_standby_express = [];
      this.daifaWarehouses = [];
      this.daifaWarehouseGifts = [];
      this.dialogTitle = "auto";
      this.dialogFormVisible = true;

      // 设置默认平台为淘宝（1）并获取仓库列表
      this.platform = 1;
      this.temp.platform = 1;
      this.getCk(0);
      
      this.temp.flag = this.orderTypes;
      this.temp.cg_platform = this.buyPlatforms;
      this.temp.kuai_name = this.kuaidiLists;
      this.getShowName();

      const url = this.$root.commonPreUrl + "/index/zdSend";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200" && resd.data != [] && resd.data.length != 0) {
            let data = resd.data;
            this.temp.type = 2;
            if (data.ext_5 != "") {
              const ext_5 = JSON.parse(data.ext_5);
              this.temp.ids = JSON.parse(ext_5.cang_ids);
              this.temp.standby_express = JSON.parse(ext_5.standby_express);
              this.send_name = ext_5.send_name;
              
              let zd_plat = Number(ext_5.platform);
              if (zd_plat == undefined) {
                zd_plat = 1;
              }
              this.temp.platform = zd_plat;
              this.platform = zd_plat;
              
              const savedIds = this.temp.ids;
              const savedGoodsId = ext_5.goods_id || '';
              
              this.getCk(1).then(() => {
                if (savedIds && savedIds.length > 0) {
                  savedIds.forEach((item) => {
                    this.df_ids.push(item.id);
                    this.daifaWarehouses.push({
                      warehouse_id: item.id + '',
                      gift_ids: savedGoodsId ? [savedGoodsId + ''] : []
                    });
                    this.daifaWarehouseGifts.push([]);
 
                    const warehouseIndex = this.daifaWarehouses.length - 1;
                    this.onDaifaWarehouseChange(warehouseIndex);
                  });
                } else {
                  this.addDaifaWarehouse();
                }
              });
              this.temp.standby_express.forEach((item) => {
                this.df_standby_express.push(item.id);
              })
              this.cangkuClick();
              this.temp.fjr = ext_5.send_name + "," + ext_5.send_mobile;
              // this.temp.goods_id = ext_5.goods_id;
            }
            if (data.ext_6 != "") {
              const ext_6 = JSON.parse(data.ext_6);
              this.temp.zdy_phone = ext_6.zdy_phone;
              this.temp.gift_status = ext_6.gift_status;
              this.temp.wuhuoyu_orderStatus = ext_6.status;
              this.temp.kuai_name = ext_6.kuai_name;
              this.temp.express_type = ext_6.express_type;
              this.temp.cg_platform = ext_6.cg_platform;
              this.temp.flag = ext_6.flag;
              if (ext_6.shop_name == "0") {
                this.temp.show_name = "全部";
              } else {
                this.temp.show_name = ext_6.shop_name;
              }
              if (ext_6.shop_group_name == "0") {
                this.temp.shop_group_name = "全部";
              } else {
                this.temp.shop_group_name = ext_6.shop_group_name;
              }
            }
            // this.temp.orderStatus= ext_5
            // this.temp.cstime= ext_5.  ;
          } else {
            // 如果没有保存的数据，获取仓库列表并添加一个空的代发仓库行
            this.platform = 1;
            this.temp.platform = 1;
            this.getCk(0).then(() => {
              if (this.daifaWarehouses.length === 0) {
                this.addDaifaWarehouse();
              }
            });
          }
          setTimeout(() => {}, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, // 是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }
        });
    },
    // 超时 礼品单 自动发货物流设置  获取弹窗信息
    getTimeoutZdSendInfo() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.resetTemp();
      this.dialogTitle = "timeout";
      this.dialogFormVisible = true;

      // 设置默认平台为淘宝（1）并获取仓库列表
      this.platform = 1;
      this.temp.platform = 1;
      this.getCk(0);
      
      this.temp.flag = this.orderTypes;
      this.temp.cg_platform = this.buyPlatforms;
      this.getShowName();

      const url = this.$root.commonPreUrl + "/index/zdSend";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200" && resd.data.length != 0) {
            let data = resd.data;
            this.temp.type = 1;
            if (data.ext_2 != "") {
              const ext_2 = JSON.parse(data.ext_2);
              this.temp.id = ext_2.cang_id;
              this.cangkuClick();
              this.temp.fjr = ext_2.send_name + "," + ext_2.send_mobile;
              // this.temp.goods_id = ext_2.goods_id;
            }
            if (data.ext_1 != "") {
              const ext_1 = JSON.parse(data.ext_1);
              // this.temp.zdy_phone = ext_1.zdy_phone;
              this.temp.gift_status = ext_1.gift_status;
              this.temp.orderStatus = ext_1.status;
              this.temp.cstime = ext_1.cstime;
              // this.temp.kuai_name = ext_1.kuai_name;
              // this.temp.express_type = ext_1.express_type;
              this.temp.cg_platform = ext_1.cg_platform;
              this.temp.flag = ext_1.flag;
              if (ext_1.shop_name == "0") {
                this.temp.show_name = "全部";
              } else {
                this.temp.show_name = ext_1.shop_name;
              }
              if (ext_1.shop_group_name == "0") {
                this.temp.shop_group_name = "全部";
              } else {
                this.temp.shop_group_name = ext_1.shop_group_name;
              }
              // this.temp.show_name = ext_1.shop_name;
              // this.temp.shop_group_name = ext_1.shop_group_name;
            }
          }
          setTimeout(() => {}, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, // 是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }
        });
    },
    kqZdSend() {},
    getCk(isZdinfo) {
      // 更换平台时，调用接口获取平台对应仓库列表
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.cangkuList = [];
      if (isZdinfo != 1) {
        this.temp.id = "";
        this.temp.fhAddress = "";
        this.goods = [];

        this.temp.ids = [];
        this.temp.standby_express = [];

        this.df_ids = [];
      }
      // this.df_ids = [];
      // this.df_standby_express = [];

      const url = this.$root.commonPreUrl + "/index/getCk";
      const system_id = Cookies.get("view_system_id");
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: { platform: this.platform, system_id: system_id },
      });
      return res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.cangkuList = resd.data;
            this.tbd_cangkuList = [];
            this.lpd_cangkuList = [];
            this.cangkuList.forEach((item) => {
              if (item.type == 1) {
                this.tbd_cangkuList.push(item);
              } else {
                this.lpd_cangkuList.push(item);
              }

              if (item.kuaidi && item.kuaidi.pic) {
                item.kuaidi.pic = this.$root.staticUrl + "storage/" + item.kuaidi.pic;
              }

              if (item.desc_name && item.processed_member) {
                item.desc_name = item.desc_name + "， ￥" + item.processed_member;
              }

              if (item.goods && Array.isArray(item.goods)) {
                item.goods.forEach((gitem, index) => {
                  if (gitem && gitem.pic) {
                    gitem.pic = this.$root.staticUrl + "storage/" + gitem.pic;
                  }
                });
              }
            });
          }
          return response;
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, // 是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }
          throw error;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },

    cangkuClick() {
      const selected_cid = this.temp.id;
      // 使用forEach方法遍历数组并取值
      this.cangkuList.forEach((item, index) => {
        const cid = item.id;
        if (cid == selected_cid) {
          // 选择仓库后对应快递名称
          this.temp.kuaidi_name = item.kuaidi.desc_name;
          // 快递费  先取当前登录用户等级
          // const grade = Cookies.get("view_grade");
          this.temp.kuaidi_price = item.processed_member;
          // 给发货地址赋值
          this.temp.fhAddress = item.address;
          //  给代发礼品赋值
          this.goods = item.goods;
        }
      });
    },
    getShowName() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      const url = this.$root.commonPreUrl + "/index/getShowName";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "1") {
            this.shopGroupList = resd.data.group_name;
            this.shopList = resd.data.shop_name;
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, // 是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
    getShowNameByGroup() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      const url = this.$root.commonPreUrl + "/index/getShowName";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: { shop_group_name: this.temp.shop_group_name },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "1") {
            this.shopList = resd.data.shop_name;
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, // 是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
    autoSendGoodsOn(onType) {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }
      const sendTel = this.send_tel;
      if (
        sendTel == "" ||
        sendTel == "null" ||
        sendTel == null ||
        sendTel == undefined ||
        sendTel == "undefined"
      ) {
        this.$confirm("请先选择正确的发件人电话！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            return;
          })
          .catch(() => {
            return;
          });
        return;
      }
      let sendName = this.send_name;
      if (sendName == "") {
        sendName = "1";
      }
      this.temp.fjr = sendName + "," + sendTel;

      // 判断 是否已设置仓库等信息  若未设置  不能开启
      if (this.dialogTitle == "auto") {
        // 从代发仓库数据中提取仓库ID
        const daifaWarehouseIds = this.daifaWarehouses
          .filter(p => p.warehouse_id && p.warehouse_id !== '')
          .map(p => p.warehouse_id);
        
        if (daifaWarehouseIds.length == 0) {
          this.$confirm("请先设置仓库等发货信息并保存后再开启自动发货!", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, // 是否显示取消按钮
          })
            .then(() => {
              if (onType == "tbwl_auto") {
                this.tbwl_auto = 0;
                this.df_ids = [];
                this.df_standby_express = [];
              } else {
                this.fhcs_auto = 0;
              }
              this.dialogFormVisible = false;
            })
            .catch(() => {});
          return;
        }
        
        // 验证每个仓库是否都选择了至少一个礼品
        const warehousesWithoutGifts = this.daifaWarehouses.filter(
          p => p.warehouse_id && p.warehouse_id !== '' && (!p.gift_ids || p.gift_ids.length === 0)
        );
        if (warehousesWithoutGifts.length > 0) {
          this.$confirm("请为每个代发仓库至少选择一个礼品!", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, // 是否显示取消按钮
          })
            .then(() => {
              if (onType == "tbwl_auto") {
                this.tbwl_auto = 0;
              } else {
                this.fhcs_auto = 0;
              }
              return;
            })
            .catch(() => {});
          return;
        }
        
        if(daifaWarehouseIds.filter(item => this.df_standby_express.includes(item)).length > 0){
          this.$confirm("备选仓库不能选择代发仓库已选择的仓库选项!", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, // 是否显示取消按钮
          })
            .then(() => {
              if (onType == "tbwl_auto") {
                this.tbwl_auto = 0;
                this.df_ids = [];
                this.df_standby_express = [];
              } else {
                this.fhcs_auto = 0;
              }
              return;
             // this.dialogFormVisible = false;
            })
            .catch(() => {});
            return;
        }
        // 更新df_ids为代发仓库中的仓库ID
        this.df_ids = daifaWarehouseIds;
        
        // 构建新的数据结构：{ "仓库ID": { "warehouse_type": 类型, "goods_id": 礼品ID } }
        const daifaWarehouseData = {};
        this.daifaWarehouses
          .filter(p => p.warehouse_id && p.warehouse_id !== '' && p.gift_ids && p.gift_ids.length > 0)
          .forEach(p => {
            // 查找仓库的 warehouse_type
            const warehouse = this.tbd_cangkuList.find(item => item.id == p.warehouse_id);
            if (warehouse) {
              const goodsId = parseInt(p.gift_ids[0]);
              daifaWarehouseData[p.warehouse_id] = {
                warehouse_type: warehouse.warehouse_type,
                goods_id: goodsId
              };
            }
          });
        
        this.temp.ids = JSON.stringify(daifaWarehouseData);
      } else if (this.dialogTitle == "timeout") {
        if (this.temp.id == "" || this.temp.id == null || this.temp.id == undefined) {
          this.$confirm("请先设置仓库等发货信息并保存后再开启自动发货!", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, // 是否显示取消按钮
          })
            .then(() => {
              if (onType == "tbwl_auto") {
                this.tbwl_auto = 0;
              } else {
                this.fhcs_auto = 0;
              }
              // this.dialogFormVisible = false;
            })
            .catch(() => {});
          return;
        }
      }

      if (this.dialogTitle == "timeout") {
        let idMap = [];
        let df_types = [];
        this.df_ids.forEach((item) => {
          this.tbd_cangkuList.forEach((item1) => {
            if (item == item1.id) {
              idMap.push({id:item, warehouse_type:item1.warehouse_type});
              df_types.push(item1.warehouse_type);
            }
          })
        })
        this.temp.ids = idMap;
      }

      let standby_expressMap = [];
      if (this.df_standby_express.length != 0 && this.df_standby_express != null && this.df_standby_express != undefined) {
        this.df_standby_express.forEach((item) => {
          this.tbd_cangkuList.forEach((item1) => {
            if (item == item1.id) {
              standby_expressMap.push({id:item, warehouse_type:item1.warehouse_type});
            }
          })
        })
      }
      
      this.temp.standby_express = standby_expressMap;
      if (this.dialogTitle == "timeout") {
        this.temp.ids = JSON.stringify(this.temp.ids);
      }
      this.temp.platform = this.platform;
      this.temp.standby_express = JSON.stringify(this.temp.standby_express);
      // 判断是否已开启  需要先关闭再修改 再重新开启
      if (this.dialogTitle == "auto") {
        const tbwl_auto = this.tbwl_auto;
        if (tbwl_auto == 1 || tbwl_auto == "1") {
          this.$confirm("同步自动发货已开启，请先关闭后再修改-保存!", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, // 是否显示取消按钮
          })
            .then(() => {
              this.dialogFormVisible = false;
            })
            .catch(() => {});
          return;
        }
        this.temp.type = 2;
      } else if (this.dialogTitle == "timeout") {
        const fhcs_auto = this.fhcs_auto;
        if (fhcs_auto == 1 || fhcs_auto == "1") {
          this.$confirm("超时自动发货已开启，请先关闭后再修改-保存!", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, // 是否显示取消按钮
          })
            .then(() => {
              this.dialogFormVisible = false;
            })
            .catch(() => {});
          return;
        }
        this.temp.type = 1;
      }
      // if (this.dialogTitle == "auto" && this.daifaWarehouses.length > 0) {
      //   const firstWarehouse = this.daifaWarehouses.find(p => p.gift_ids && p.gift_ids.length > 0);
      //   if (firstWarehouse && firstWarehouse.gift_ids.length > 0) {
      //     this.temp.goods_id = firstWarehouse.gift_ids[0];
      //     const gift = this.cangkuList
      //       .flatMap(item => item.goods || [])
      //       .find(g => g.id == firstWarehouse.gift_ids[0]);
      //     if (gift) {
      //       this.temp.goods_price = gift.member;
      //     }
      //   }
      // } else if (this.goods.length > 0) {
      //   this.temp.goods_id = this.goods[0].id;
      //   this.temp.goods_price = this.goods[0].member;
      // }
      if (this.temp.show_name == "全部") {
        this.temp.show_name = "0";
      }
      if (this.temp.shop_group_name == "全部") {
        this.temp.shop_group_name = "0";
      }
      let url = "";
      if (this.dialogTitle == "auto") {
        url = this.$root.commonPreUrl + "/index/autoSendGoodsOnV2";
      } else if (this.dialogTitle == "timeout"){
        url = this.$root.commonPreUrl + "/index/autoSendGoodsOn";
      }

      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: this.temp,
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            if (resd.message == "自动发货开启成功！") {
              this.dialogFormVisible = false;
              if (this.dialogTitle == "auto") {
                this.tbwl_auto = 1;
                Cookies.set("view_tbwl_auto", 1, { expires: 1 });
                this.$notify({
                  title: "成功",
                  message: "无货源自动发货开启成功",
                  type: "success",
                  duration: 2000,
                });
                
                this.df_ids = [];
                this.df_standby_express = [];
                this.resetTemp();
              } else if (this.dialogTitle == "timeout") {
                this.fhcs_auto = 1;
                Cookies.set("view_fhcs_auto", 1, { expires: 1 });
                this.$notify({
                  title: "成功",
                  message: "超时自动发货开启成功",
                  type: "success",
                  duration: 2000,
                });
                this.resetTemp();
              }
            } else {
              this.$confirm(resd.message, "提示", {
                confirmButtonText: "确认",
                showCancelButton: false, // 是否显示取消按钮
              })
                .then(() => {})
                .catch(() => {});
            }
          } else {
            if (this.dialogTitle == "auto") {
              this.df_ids = [];
              this.df_standby_express = [];
              this.tbwl_auto = 0;
              Cookies.set("view_tbwl_auto", 0, { expires: 1 });
            } else if (this.dialogTitle == "timeout") {
              this.fhcs_auto = 0;
              Cookies.set("view_fhcs_auto", 0, { expires: 1 });
            }
            this.$confirm(resd.message, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, // 是否显示取消按钮
            })
              .then(() => {
                this.df_ids = [];
                this.df_standby_express = [];
              })
              .catch(() => {});
          }
          setTimeout(() => {}, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, // 是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                this.df_ids = [];
                this.df_standby_express = [];
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }
        });
    },

    getYunDaError() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.listLoading = true;
      const url = this.$root.commonPreUrl + "/index/getYunDaError";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            const yunDaErrorList = resd.data;
            if (yunDaErrorList.length > 0) {
              let data = "";
              yunDaErrorList.forEach((item) => {
                data =
                  data +
                  "韵达订单编号:[" +
                  item.order_no +
                  "]，生成韵达单号:[" +
                  item.storeMailNo +
                  "]因地址无法到达关联失败，请使用其他单号发送; \n ";
              });
              this.yundaErrorData.data = data;
              this.yunda_dialogFormVisible = true;
            }
          }
          setTimeout(() => {}, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, // 是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }
        });
    },
    resetTemp() {
      this.temp = {
        id: "",
        ids: [],
        standby_express: [],
        type: 0,
        zdy_phone: "",
        fjr: Cookies.get("view_fjr"),
        kuaidi_price: "",
        // goods_price: "",
        // goods_id: "",
        gift_status: 1,
        wuhuoyu_orderStatus: 3,
        orderStatus: 4,
        cstime: 0,
        kuai_name: [],
        express_type: 1,
        cg_platform: [],
        flag: [],
        show_name: "全部",
        shop_group_name: "全部",
        kuaidi_name: "",
        fhAddress: "",
        express_type: 0,
        platform: 1,
      };
    },
    autoSendOnOff(type) {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.temp.type = type;
      if (type == 2) {
        const tbwl_kg = this.tbwl_auto;
        if (tbwl_kg == 0) {
          const url = this.$root.commonPreUrl + "/index/autoSendGoodsOff";
          const res = axios.get(url, {
            headers: {
              Authorization: "Bearer " + userToken,
            },
            params: this.temp,
          });
          res
            .then((response) => {
              const resd = response.data;
              if (resd.code == "200") {
                Cookies.set("view_tbwl_auto", 0, { expires: 1 });
                this.$notify({
                  title: "成功",
                  message: "无货源自动发货关闭成功",
                  type: "success",
                  duration: 2000,
                });
              }
              setTimeout(() => {}, 1.5 * 1000);
            })
            .catch((error) => {
              console.error("初始请求失败:", error);
              if (
                JSON.stringify(error).includes(
                  "Error: Request failed with status code 401"
                )
              ) {
                this.$confirm("登录信息已失效，请重新登录!", "提示", {
                  confirmButtonText: "确认",
                  showCancelButton: false, // 是否显示取消按钮
                })
                  .then(() => {
                    // 重新导航到首页
                    localStorage.clear();
                    this.$root.removeCookies();
                    this.$router.push({ path: "/login" });
                  })
                  .catch(() => {});
              }
            });
        } else if (tbwl_kg == 1) {
          this.dialogTitle = "auto";
          this.autoSendGoodsOn("tbwl_auto");
        }
      } else if (type == 1) {
        const fhcs_kg = this.fhcs_auto;
        if (fhcs_kg == 0) {
          const url = this.$root.commonPreUrl + "/index/autoSendGoodsOff";
          const res = axios.get(url, {
            headers: {
              Authorization: "Bearer " + userToken,
            },
            params: this.temp,
          });
          res
            .then((response) => {
              const resd = response.data;
              if (resd.code == "200") {
                Cookies.set("view_fhcs_auto", 0, { expires: 1 });
                this.$notify({
                  title: "成功",
                  message: "超时自动发货关闭成功！",
                  type: "success",
                  duration: 2000,
                });
              }
              setTimeout(() => {}, 1.5 * 1000);
            })
            .catch((error) => {
              console.error("初始请求失败:", error);
              if (
                JSON.stringify(error).includes(
                  "Error: Request failed with status code 401"
                )
              ) {
                this.$confirm("登录信息已失效，请重新登录!", "提示", {
                  confirmButtonText: "确认",
                  showCancelButton: false, // 是否显示取消按钮
                })
                  .then(() => {
                    // 重新导航到首页
                    localStorage.clear();
                    this.$root.removeCookies();
                    this.$router.push({ path: "/login" });
                  })
                  .catch(() => {});
              }
            });
        } else if (fhcs_kg == 1) {
          this.dialogTitle = "timeout";
          this.autoSendGoodsOn("fhcs_auto");
        }
      }
    },
    addClass: function (plat) {
      this.platform = plat;
      this.getCk(0);
    },
    sendCode() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      if (this.countdown > 0) {
        return;
      }
      let phoneNum = this.phoneForm.phone;
      if (phoneNum == "" || phoneNum == null) {
        // alert("请输入手机号！");
        this.$confirm("请输入手机号！", "提示", {
          confirmButtonText: "确认",
          showCancelButton: false, //是否显示取消按钮
        })
          .then(() => {
            return;
          })
          .catch(() => {});
        return;
      }
      const url = this.$root.commonPreUrl + "/sendVerificationCode";
      const res = axios.get(url, {
        params: { phone: phoneNum },
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            // 设置倒计时时间，这里设置为60秒
            this.countdown = 60;
            // 创建倒计时
            const intervalId = setInterval(() => {
              if (this.countdown > 0) {
                this.countdown -= 1;
              } else {
                clearInterval(intervalId);
              }
            }, 1000);
          } else {
            this.$confirm(
              "发送失败！原因：" + JSON.stringify(response.data.message),
              "提示",
              {
                confirmButtonText: "确认",
                showCancelButton: false, //是否显示取消按钮
              }
            )
              .then(() => {
                return;
              })
              .catch(() => {});
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          this.$confirm("操作失败！请稍后刷新重试。", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, //是否显示取消按钮
          })
            .then(() => {})
            .catch(() => {});
          return;
        });
    },
    sendCodeCheck() {
      this.sendCodeFormVisible = true;
    },
    updateUserInfo() {
      const userToken = Cookies.get("view_userToken");
      const userId = Cookies.get("view_userId");
      if (userToken == undefined || userId == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return "";
      }
      const url = this.$root.commonPreUrl + "/verifyVerificationCode";
      const res = axios.get(url, {
        params: { phone: this.phoneForm.phone, code: this.phoneForm.code },
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            // 提交修改手机号
            const url = this.$root.commonPreUrl + "/index/updateUserInfo";
            this.sendtelList.push(this.phoneForm.phone);
            let sendtel_json = JSON.stringify(this.sendtelList);

            const res1 = axios.get(url, {
              params: { id: userId, send_name: this.send_name, send_tel: sendtel_json },
              headers: {
                Authorization: "Bearer " + userToken,
              },
            });
            res1.then((response) => {
              const resd1 = response.data;
              if (resd1.code == "200") {
                this.sendCodeFormVisible = false;
                this.$confirm(resd1.message, "提示", {
                  confirmButtonText: "确认",
                  showCancelButton: false, //是否显示取消按钮
                })
                  .then(() => {})
                  .catch(() => {});
              } else {
                this.$confirm(resd1.message, "提示", {
                  confirmButtonText: "确认",
                  showCancelButton: false, //是否显示取消按钮
                })
                  .then(() => {})
                  .catch(() => {});
              }
            });
          } else {
            this.$confirm(resd.message, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {})
              .catch(() => {});
            return;
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          this.$confirm("操作失败！请稍后刷新重试。", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, //是否显示取消按钮
          })
            .then(() => {})
            .catch(() => {});
          return;
        });
    },
    sendTelClick() {
      let sendName = this.send_name;
      if (sendName == "") {
        sendName = "1";
      }
      this.lpfsQuery.fjr = sendName + "," + this.send_tel;
    },

    liClicked(item) {
      this.send_tel = item;
      let sendName = this.send_name;
      if (sendName == "") {
        sendName = "a1";
      }
      this.lpfsQuery.fjr = sendName + "," + this.send_tel;
    },
    deleteItem(item) {
      this.sendtelList = this.sendtelList.filter((i) => i !== item);

      const userToken = Cookies.get("view_userToken");
      const userId = Cookies.get("view_userId");
      if (userToken == undefined || userId == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return "";
      }
      const url = this.$root.commonPreUrl + "/index/updateUserInfo";
      let sendtel_json = JSON.stringify(this.sendtelList);

      const res1 = axios.get(url, {
        params: { id: userId, send_name: this.send_name, send_tel: sendtel_json },
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });
      res1.then((response) => {
        const resd1 = response.data;
        if (resd1.code == "200") {
          this.sendCodeFormVisible = false;
          this.$root.getUserInfo();
          this.$confirm("手机号删除成功！", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, //是否显示取消按钮
          })
            .then(() => {})
            .catch(() => {});
        } else {
          this.$confirm(resd1.message, "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, //是否显示取消按钮
          })
            .then(() => {})
            .catch(() => {});
        }
      });
    },

    // 添加代发仓库
    addDaifaWarehouse() {
      this.daifaWarehouses.push({
        warehouse_id: '',
        gift_ids: []
      });
      this.daifaWarehouseGifts.push([]);
    },
    // 删除代发仓库
    removeDaifaWarehouse(index) {
      this.daifaWarehouses.splice(index, 1);
      this.daifaWarehouseGifts.splice(index, 1);
    },
    // 当选择仓库时，更新对应的礼品列表
    onDaifaWarehouseChange(index) {
      const warehouseId = this.daifaWarehouses[index].warehouse_id;
      // 清空当前选择的礼品
      this.daifaWarehouses[index].gift_ids = [];
      
      // 根据选择的仓库，获取对应的礼品列表
      let selectedWarehouse = null;
      this.cangkuList.forEach((item) => {
        if (item.id == warehouseId) {
          selectedWarehouse = item;
        }
      });
      
      if (selectedWarehouse && selectedWarehouse.goods && Array.isArray(selectedWarehouse.goods)) {
        const goods = selectedWarehouse.goods.map(gitem => {
          if (!gitem) return null;
          return {
            ...gitem
          };
        }).filter(item => item !== null);
        this.$set(this.daifaWarehouseGifts, index, goods);
      } else {
        this.$set(this.daifaWarehouseGifts, index, []);
      }
    },
  },
};
</script>

<style scoped>
.lipin_img_div {
  width: 10vw;
  /* min-height: 22.5vh; */
  /* border: #0850fc 1px solid; */
  /* background-color: #d5e1ff; */
  color: rgb(37, 37, 37);
  margin-left: 73px;
  margin-top: -20px;
}
.lipin_img {
  width: 8vw;
  height: 8vw;
}
.el-form-item__content {
  line-height: 25px;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  max-width: 87%;
  vertical-align: middle;
}
.platDiv {
  width: 80px;
  height: 32px;
  border: #0850fc solid 1px;
  border-radius: 0.5em;
  float: left;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  margin-right: 20px;
}
.platSpan {
  font-size: 16px;
  padding: 0px 7px;
}
.spanColors {
  font-weight: bold;
  background-color: #0850fc;
  color: white;
}
.form a {
  position: absolute;
  text-decoration: none;
  right: 10px;
  color: #a9a9a9;
  border-left: 1px solid #ccc;
  align-items: center;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/syncOrder/autoSend/index.vue